import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface ParamsInputDialogData {
  title: string;
  message: string;
}

export interface ParamsInputResult {
  pathParams: string[];
  queryParams: { [key: string]: string };
}

@Component({
  selector: 'app-params-input-dialog',
  templateUrl: './params-input-dialog.component.html',
  styleUrls: ['./params-input-dialog.component.scss']
})
export class ParamsInputDialogComponent {
  pathParamsList: string[] = [];
  queryParamsList: Array<{ key: string; value: string }> = [];

  constructor(
    public dialogRef: MatDialogRef<ParamsInputDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ParamsInputDialogData
  ) {}

  addPathParam(): void {
    this.pathParamsList.push('');
  }

  addQueryParam(): void {
    this.queryParamsList.push({ key: '', value: '' });
  }

  trackByIndex(index: number, item: any): number {
    return index;
  }

  removePathParam(index: number): void {
    this.pathParamsList.splice(index, 1);
  }

  removeQueryParam(index: number): void {
    this.queryParamsList.splice(index, 1);
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onConfirm(): void {
    // Filtrar valores vacíos de path params
    const pathParams = this.pathParamsList.filter(p => p && p.trim());
    
    // Filtrar y construir query params solo con valores completos
    const queryParams: { [key: string]: string } = {};
    this.queryParamsList.forEach(param => {
      if (param.key && param.key.trim() && param.value && param.value.trim()) {
        queryParams[param.key.trim()] = param.value.trim();
      }
    });
    
    const result: ParamsInputResult = {
      pathParams,
      queryParams
    };
    
    console.log("Parámetros a enviar:", result);
    
    this.dialogRef.close(result);
  }
}
